var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseRedBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.326,
    height: 65.343,
    viewBox: "0 0 65.326 65.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_83147",
    "data-name": "Path 83147",
    d: "M124.027,46.8l23.943-23.943a5.108,5.108,0,0,0-7.224-7.224L116.8,39.579,92.86,15.637a5.108,5.108,0,1,0-7.224,7.224L109.578,46.8,85.636,70.746a5.126,5.126,0,0,0,3.578,8.738,4.841,4.841,0,0,0,3.578-1.514L116.8,54.028,140.745,77.97a5.117,5.117,0,0,0,3.578,1.514A4.841,4.841,0,0,0,147.9,77.97a5.108,5.108,0,0,0,0-7.224Z",
    transform: "translate(-84.14 -14.141)",
    fill: "#db2828"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRedBig);
export default __webpack_public_path__ + "static/media/closeRedBig.eab2cb5816cebe208336cba157e45776.svg";
export { ForwardRef as ReactComponent };